import request from '@/request'

export const datagrid = data => {
  return request({
    url: '/exterior_intFtuMedicalMutualReferenceinfo/datagrid.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const getAuthority = data => {
  return request({
    url: '/exFtuMedicalMutualDeclareinfo/getAuthority.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const getArea = data => {
  return request({
    url: '/exFtuMedicalMutualDeclareinfo/getArea.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const getMyMedicalDec = data => {
  return request({
    url: '/exFtuMedicalMutualDeclareinfo/getMyMedicalDec.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const medicalDecList = data => {
  return request({
    url: '/exFtuMedicalMutualDeclareinfo/medicalDecList.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 审核拒绝
export const auditingNo = data => {
  return request({
    url: '/exFtuMedicalMutualDeclareinfo/auditingNo.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 审核
export const auditing = data => {
  return request({
    url: '/exFtuMedicalMutualDeclareinfo/auditing.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 批量审核
export const auditingP = data => {
  return request({
    url: '/exFtuMedicalMutualDeclareinfo/auditingP.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const medicalDecListHis = data => {
  return request({
    url: '/exFtuMedicalMutualDeclareinfo/medicalDecListHis.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const getUserInfo = data => {
  return request({
    url: '/exFtuMedicalMutualDeclareinfo/getUserInfo.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const getcheckList = data => {
  return request({
    url: '/exFtuMedicalMutualDeclareinfo/check.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 获取报销费用
export const getcost = data => {
  return request({
    url: '/exFtuMedicalMutualDeclareinfo/cost.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 获取地市
export const FTU_WXCP_DEPARTNEW = data => {
  return request({
    url: '/sysDd/FTU_WXCP_DEPARTNEW.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 获取地市
export const checkHB = data => {
  return request({
    url: '/exFtuMedicalMutualDeclareinfo/checkHB.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const checkCB = data => {
  return request({
    url: '/exFtuMedicalMutualDeclareinfo/checkCB.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const addList = data => {
  return request({
    url: '/exFtuMedicalMutualDeclareinfo/add.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const editList = data => {
  return request({
    url: '/exFtuMedicalMutualDeclareinfo/edit.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const zycost = data => {
  return request({
    url: '/exFtuMedicalMutualDeclareinfo/zycost.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const getMyMedicalBase = data => {
  return request({
    url: '/exFtuMedicalMutualDeclareinfo/getMyMedicalBase.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const getMedicalLog = data => {
  return request({
    url: '/exFtuMedicalMutualDeclareinfo/getMedicalLog.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
